module.exports = __webpack_public_path__ + "img/renter-interview.7aec22b.png";